import * as React from "react";
import PropTypes from "prop-types";
import Bacon from "baconjs";
import DumbPivotNumericUpDownPicker from "./DumbPivotNumericUpDownPicker";

/* eslint-disable no-unused-vars */
const { onDown, onUp, ...propTypesFromDumbPivotNumericUpDownPicker } =
  DumbPivotNumericUpDownPicker.propTypes || {};
/* eslint-enable no-unused-vars */

export default class PivotNumericUpDownPicker extends React.Component {
  static propTypes = {
    ...propTypesFromDumbPivotNumericUpDownPicker,
    // Called when the user starts interacting with the controls
    onChangesStarted: PropTypes.func,
    // Called after the user has interacted with the controls
    // and then hasn't touched them for `changeBufferMs` ms
    onChangesEnded: PropTypes.func,
    // Called whenever some user interaction updates the value.
    onValue: PropTypes.func,
    changeBufferMs: PropTypes.number,
  };

  static defaultProps = {
    min: 55,
    max: 95,
    value: 70,
    step: 1,
    unit: "°",
    changeBufferMs: 2000,
  };

  state = { value: this.props.value };

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ value: nextProps.value });
  }

  componentDidMount() {
    this._setUpBacon();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.changeBufferMs === this.props.changeBufferMs) {
      return;
    }
    this._tearDownBacon();
    this._setUpBacon();
  }

  componentWillUnmount() {
    this._tearDownBacon();
  }

  _setUpBacon() {
    this._valuesStream = new Bacon.Bus(); // contains values (numeric)
    this._isNotPressedStream = new Bacon.Bus();
    this._valuesStream.onValue((targetValue) => {
      const clampedValue = Math.max(
        this.props.min,
        Math.min(this.props.max, targetValue)
      );
      if (this.state.value !== clampedValue) {
        this.setState({ value: clampedValue });
      }
      if (this.props.onValue) {
        this.props.onValue(clampedValue);
      }
    });

    const isNotPressed = this._isNotPressedStream.toProperty(true);

    const startEvents = this._valuesStream
      .merge(this._isNotPressedStream)
      .debounceImmediate(this.props.changeBufferMs)
      .map(() => "start");

    const endEvents = this._valuesStream
      .merge(this._isNotPressedStream)
      .debounce(this.props.changeBufferMs)
      .filter(isNotPressed)
      .map(() => "end");

    startEvents
      .merge(endEvents)
      .skipDuplicates()
      .onValue((event) => {
        if (event === "start" && this.props.onChangesStarted) {
          this.props.onChangesStarted();
        } else if (event === "end" && this.props.onChangesEnded) {
          this.props.onChangesEnded();
        }
      });
  }

  _tearDownBacon() {
    this._valuesStream.end();
    this._isNotPressedStream.end();
  }

  handleUp = () => {
    this._valuesStream.push(this.state.value + this.props.step);
  };

  handleDown = () => {
    this._valuesStream.push(this.state.value - this.props.step);
  };

  render() {
    return (
      <DumbPivotNumericUpDownPicker
        {...this.props}
        value={this.state.value}
        onUp={this.handleUp}
        onDown={this.handleDown}
      />
    );
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/PivotNumericUpDownPicker/index.jsx